export default function CRealloc() {
  return <h2>C Realloc</h2>;
}
